import { defineNuxtPlugin } from "nuxt/app";
import animatePop from "@/directives/animatePop";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("animate-pop", animatePop);
});
